export enum AssessmentPageType {
    DCT_TOOL_DOWNLOAD = 'DCT_TOOL_DOWNLOAD',
    VMA_OPPORTUNITIES = 'VMA_OPPORTUNITIES',
    DCT_OPPORTUNITIES = 'DCT_OPPORTUNITIES',
}

export class AssessmentPageTypeResponse {
    type: AssessmentPageType;

    constructor(json: any) {
        this.type = json.type as AssessmentPageType;
    }
}

export class OpportunityListResponse {
    id: number;
    name: string;
    accountName: string;
    createdDate: Date;
    createdBy: string;
    updatedDate: Date;
    updatedBy: string;
    sites: SiteListResponse[];

    constructor(json: any) {
        this.id = json.id;
        this.name = json.name;
        this.accountName = json.account_name;
        this.createdDate = new Date(json.created_date);
        this.createdBy = json.created_by;
        this.updatedDate = new Date(json.updated_date);
        this.updatedBy = json.updated_by;
        this.sites = (json.sites || []).map((site: any) => new SiteListResponse(site));
    }
}

export class SiteListResponse {
    id: number;
    name: string;
    createdDate: Date;
    createdBy: string;
    updatedDate: Date;
    updatedBy: string;
    fileId: number;

    constructor(json: any) {
        this.id = json.id;
        this.name = json.name;
        this.createdDate = new Date(json.created_date);
        this.createdBy = json.created_by;
        this.updatedDate = new Date(json.updated_date);
        this.updatedBy = json.updated_by;
        this.fileId = json.file_id;
    }
}
